import * as constants from './constants';
import abbr from '../../../../config/abbr';
import { message } from 'antd';
import { apiSetCheckYzm, apiGetPyzm, apiForget,apisigncode } from '../../../../config/index';

export const toggleUserTelErr = (value, text) => ({
	type: constants.TOGGLE_USERTEL_ERR,
	value, text
})

export const togglePassErr = (value, text) => ({
	type: constants.TOGGLE_PASS_ERR,
	value, text
})

export const toggleRPassErr = (value, text) => ({
	type: constants.TOGGLE_RPASS_ERR,
	value, text
})

export const toggleYzmErr = (value, text) => ({
	type: constants.TOGGLE_YZM_ERR,
	value, text
})

export const togglePYzmErr = (value, text) => ({
	type: constants.TOGGLE_PYZM_ERR,
	value, text
})

export const handleUserTelChange = (value) => ({
	type: constants.HANDLE_USERTEL_CHANGE,
	value
})

export const handlePassChange = (value) => ({
	type: constants.HANDLE_PASS_CHANGE,
	value
})

export const handleRPassChange = (value) => ({
	type: constants.HANDLE_RPASS_CHANGE,
	value
})

export const handleYzmChange = (value) => ({
	type: constants.HANDLE_YZM_CHANGE,
	value
})

export const handlePYzmChange = (value) => ({
	type: constants.HANDLE_PYZM_CHANGE,
	value
})

export const validateUserYzm = (value) => {
	let formData = {
		imgCode: value
	}
	return (dispatch) => {
		apiSetCheckYzm(formData).then(response => {
			if(response.code == 0){
				dispatch(toggleYzmErr(false, ''));		
				return;
			}else{
				dispatch(toggleYzmErr(true, '图形验证码验证失败'));
			}
		}).catch(error => {
			console.log(error)
		})
	}
}

export const editCaptcha = () => {
	let url = abbr.ip+'/user/createcode?'+Math.random();
	return (dispatch) => {
		dispatch(setCaptcha(url))
	}
}

const setCaptcha = (url) => ({
	type: constants.SET_CAPTCHA,
	url
})

export const toggleSending = (value) => ({
	type: constants.TOGGLE_SENDING,
	value
})

export const setYzmBtnText = (text, value) => ({
	type: constants.SET_YZM_BTN_TEXT,
	text, value
})

export const setCountDownNum = (value) => ({
	type: constants.SET_COUNT_DOWN_NUM,
	value
})

export const setYzmSign = (value) => ({
	type: constants.SET_YZM_SIGN,
	value
})

//发送验证码倒计时120s
const settime = (countdown) => {
	if (countdown === 0) { 
		return (dispatch) => {
			dispatch(toggleSending(false));
			dispatch(setYzmBtnText('发送验证码', false));
			dispatch(setCountDownNum(120));
		}
	} else { 
		return (dispatch) => {
			dispatch(toggleSending(true));
			dispatch(setYzmBtnText(countdown+'s', true));
			countdown = countdown--;
			dispatch(setCountDownNum(countdown--));
			setTimeout(function() { 
				dispatch(settime(countdown));
			},1000) 
		}
	} 
}
   //获取验签
   export const getsigncode = (tel, countdown) => {
	return (dispatch) => {
		 //获取手机验证码
		 dispatch(toggleSending(true));
		 // eslint-disable-next-line
		 let randomKey = '';
		 apisigncode({}).then(response => {
			 if (response.code ==0) {
				 randomKey = response.data.randomKey;
				 console.log(randomKey)
				 dispatch(getPhonePyzm(tel, countdown,randomKey));
				 // dispatch(settime(countdown));
				 return;
			 } else {
				 dispatch(toggleSending(false));
				 message.error(response.msg);
			 }
		 }).catch(error => {
			 console.log(error)
		 })
	 }
 }
export const getPhonePyzm = (tel, countdown,randomKey) => {
	let timestamp = (new Date()).getTime();
	let formData = {
		sign: tel + ':' + timestamp + ':' + randomKey,
		type: 13
	}
	return (dispatch) => {
		//获取手机验证码
		dispatch(toggleSending(true));
		apiGetPyzm(formData).then(response => {
			if(response.code === abbr.okId){
				dispatch(setYzmSign(response.data));
				dispatch(settime(countdown));
				message.success('短信验证码已发送到你的手机，请查看哦！');
				return;
			}else{
				dispatch(toggleSending(false));
				message.error(response.msg);
			}
		}).catch(error => {
		  console.log(error)
		})
	}
}

export const forgetf = (userTel, pass, phoneYzm, phonePyzm, getSign) => {
	let formData= {
		newPwd: pass,
		phone: userTel,
		msgCode: phonePyzm,
		sign: getSign
	}
	return (dispatch) => {
		dispatch(manuBtnClickF(true));
		apiForget(formData).then(response => {
			if(response.code === abbr.okId){
				message.success('修改成功！');
				window.location.href = abbr.ipIndex+'login';
			}else{
				message.error(response.msg);
			}
			dispatch(resetForm());
			dispatch(editCaptcha());
			dispatch(manuBtnClickF(false));
		}).catch(error => {
			console.log(error)
		})
	}
}

export const resetForm = () => ({
	type: constants.RESET_FORM,
})

const manuBtnClickF = (value) => ({
	type: constants.MANU_BTN_CLICK,
	value
})